// extracted by mini-css-extract-plugin
export default {"rent":"rent_rent__maicw"};